import { useEffect, useState, useRef } from "react";
import axios from "axios";
import "./ChatWidget.css";

// ===============================
// CONFIG
// ===============================
const CHAT_ORIGIN = "https://chat.eximwatch.com";
const API_URL = "https://chat.eximwatch.com/api";

const ChatWidget = () => {

  const [open, setOpen] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const iframeRef = useRef(null);
  const sessionIntervalRef = useRef(null);

  const [session, setSession] = useState(null);
  const iframeSrcRef = useRef(null);



  // ===============================
  // SEND SESSION
  // ===============================
const sendSession = () => {

  if (!iframeRef.current?.contentWindow) return;
  if (!session) return;

  iframeRef.current.contentWindow.postMessage(
    {
      type: "SET_CHAT_SESSION",
      payload: session
    },
    CHAT_ORIGIN
  );

};

  // ===============================
  // TOGGLE CHAT
  // ===============================
  // const toggleChat = () => {

  //   if (!session) return;

  //   setOpen(prev => !prev);
  // };
  const toggleChat = () => {

  if (!session) return;

  setOpen(prev => {

    const next = !prev;

    // first time opening chat
    if (next && !iframeLoaded) {
      setIframeLoaded(true);
    }

    return next;

  });

};

  // ===============================
  // LOGIN SECONDARY
  // ===============================
  const LoginSecondary = async (userId, username, name) => {

    try {

      const res = await axios.post(
        `${API_URL}/auth/userloginSecondary`,
        { dbType: "postgres", id: userId, username, name },
        { headers: { "Content-Type": "application/json" } }
      );

      if (!res.data.success) return;

      setSession({
        accessToken: res.data.accessToken,
        refreshToken: res.data.refreshToken,
        userInfo: res.data.user,
        dbType: "postgres",
      });

    } catch (err) {
      console.error("LoginSecondary error:", err);
    }

  };

  // ===============================
  // INITIAL LOGIN
  // ===============================
  useEffect(() => {
  iframeSrcRef.current = `${CHAT_ORIGIN}/?v=${Date.now()}`;
}, []);
  useEffect(() => {

    const userRaw = localStorage.getItem("user");
    if (!userRaw) return;

    const user = JSON.parse(userRaw);

    LoginSecondary(
      user.userid,
      `${user.firstname} ${user.lastname}`,
      user.email
    );

  }, []);

  // ===============================
  // LOAD IFRAME WHEN SESSION READY
  // ===============================
  // useEffect(() => {

  //   if (!session) return;

  //   setIframeLoaded(true);

  // }, [session]);

  // ===============================
  // IFRAME LOADED
  // ===============================
  // const handleIframeLoad = () => {

  //   sendSession();

  //   // resend session for 5 seconds to guarantee delivery
  //   let attempts = 0;

  //   sessionIntervalRef.current = setInterval(() => {

  //     sendSession();

  //     attempts++;

  //     if (attempts > 10) {
  //       clearInterval(sessionIntervalRef.current);
  //     }

  //   }, 500);

  // };

  const handleIframeLoad = () => {

  let attempts = 0;

  sessionIntervalRef.current = setInterval(() => {

    // sendSession();

    // attempts++;

    // if (attempts > 20) {
    //   clearInterval(sessionIntervalRef.current);
    // }

  }, 300);

};

  // ===============================
  // RECEIVE MESSAGE
  // ===============================
useEffect(() => {

  const handleMessage = (event) => {

    if (event.origin !== CHAT_ORIGIN) return;

    if (event.data?.type === "CHAT_WIDGET_READY") {
      sendSession();
    }

    if (event.data?.type === "CHAT_INCOMING_REQUEST") {
      setOpen(true);
    }

  };

  window.addEventListener("message", handleMessage);

  return () => window.removeEventListener("message", handleMessage);

}, [session]);

  // ===============================
  // LOGOUT DETECTION
  // ===============================
  useEffect(() => {

    const handleLogout = () => {

      const userRaw = localStorage.getItem("user");

      if (!userRaw) {

        setSession(null);
        setOpen(false);
        setIframeLoaded(false);

      }

    };

    window.addEventListener("storage", handleLogout);

    return () => window.removeEventListener("storage", handleLogout);

  }, []);

  if (!session) return null;

  return (
    <>
      {/* CHAT WINDOW */}
      <div className={`chat-window ${open ? "open" : "closed"}`}>

        {open && (
        <button className="chat-close-btn" onClick={() => setOpen(false)}>
          ✖
        </button>
      )}

        {iframeLoaded && (
          <iframe
            ref={iframeRef}
            className="chat-iframe"
            src={iframeSrcRef.current}
            title="Chat"
            allow="geolocation"
            onLoad={handleIframeLoad}
          />
        )}

      </div>

      {/* CHAT ICON */}
      <div className="chat-icon" onClick={toggleChat}>
        💬
      </div>
    </>
  );
};

export default ChatWidget;